import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import AddIcon from "@mui/icons-material/Add";
import { styles } from "../../styles/Vendors.styles";

const VendorEmptyState = ({ onAddVendor, archived }) => {
  const theme = useTheme();

  return (
    <Box sx={styles.emptyState}>
      <BusinessIcon
        sx={{
          fontSize: 48,
          color: theme.customColors.icons.disabled,
          mb: 3,
        }}
      />
      <Typography
        variant="h5"
        color="textSecondary"
        sx={{ mb: 2, fontWeight: 600 }}
      >
        {archived ? "No archived vendors" : "No vendors found"}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 400, lineHeight: 1.5 }}
      >
        {archived
          ? "Vendors you archive will appear here."
          : "No vendors are currently in your register. Add a vendor manually or review vendors discovered from your connected integrations."}
      </Typography>
      {!archived && (
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: 16 }} />}
          onClick={onAddVendor}
          sx={styles.addButton}
          size="large"
        >
          Add Vendor
        </Button>
      )}
    </Box>
  );
};

export default VendorEmptyState;
